

if (posthog.getFeatureFlag('bb-02-product-page-redesign') === 'v1' && !window.location.href.includes('generic-pdp')) {
(function () {
	let lastPriceLogged = '';

	function init() {
		document.querySelector('head').insertAdjacentHTML(
			'beforeend',
			`
  <style type="text/css">
#MainContent > div:nth-child(1) > data-island > div {
    background-color: pink !important;
    display: none;
}

.selling-plan-purchase-options > div:nth-child(2) {
margin-bottom:7px;
}

document.querySelector("#MainContent > div:nth-child(4) > div:nth-child(15)") {
    top: 5% !important;
    left: 8% !important;
}

.branded-lp-buybox__pack-selector,
.branded-lp-buybox__submit-btn,
#section-template--26803322945841__icon-list,
#MainContent > div:nth-child(6) > section,
[id*='__video_with_text_'],
#shopify-section-template--26803322945841__rich_text_eApXNw,
#MainContent > div:nth-child(8) {
    display: none;
}

#shopify-section-template--26803322945841__178033953351ebd259 > section > div,
#MainContent > div:nth-child(3) > section > div {
    padding-left: 0 !important;
    padding-bottom: 0 !important;
}

#shape-divider-shape_divider_N3rfTb,
#MainContent > div:nth-child(4) > div.shape-divider.pointer-events-none.z-20.w-full.absolute.top-0.left-0.w-full,
#shape-divider-shape_divider_CcKMKz,
#MainContent > div:nth-child(7) > div,
#shape-divider-shape_divider_CMbHch,
#MainContent > div:nth-child(9) > div.shape-divider.pointer-events-none.z-20.w-full.absolute.top-0.left-0.w-full,
#shopify-section-template--26803322945841__faq_jQYm9M,
#MainContent > div:nth-child(10) {
    display: none;
}

#shopify-section-template--26803322945841__scrolling_text_qLJ8Uc > section,
#MainContent > div:nth-child(5) > section {
    padding-bottom: 80px;
}

[id*='icon-row-template--'] {
    padding-top: 80px;
    padding-bottom: 60px;
}

#shopify-section-template--26803322945841__178033953351ebd259 > section,
#MainContent > div:nth-child(3) > section {
    display: flex;
}

.branded-lp-buybox {
    display: block !important;
}

#MainContent > div:nth-child(3) > section > div,
#MainContent > div:nth-child(11) > section > div {
    display: block !important;
}

.bb-mobile-header-clone {
    margin-bottom: 30px;
}

img[src*='bean' i] {
    display: none !important;
}

.bb-icon {
    width: 100px !important;
    height: 100px !important;
}

@media (max-width: 1650px) {
    .bb-radius > .bb-icon {
        width: 80px !important;
        height: 80px !important;
    }
}

@media (max-width: 1190px) {
    .bb-radius > .bb-icon {
        width: 70px !important;
        height: 70px !important;
    }
}

.product-block-price,
.product-block-quantity-selector {
    display: none !important;
}

div[id^='shopify-section-'][id*='__product_new_']
    > data-island
    > div.section-content.relative.z-10.mx-auto.max-w-site.py-section-vertical-spacing.lg\\:px-section {
    padding-bottom: 20px;
}

/* Custom Amazon Link Styles */
.custom-amazon-link-wrapper {
    margin-top: 56px;
    display: none;
    width: 100%;
    justify-content: flex-start;
}

.custom-amazon-link-wrapper img {
    height: 40px;
    width: auto;
    object-fit: contain;
    display: block;
}

@media (max-width: 1023px) {
    .product-block-container > .relative > .product-block > a > h2.font-heading,
    .product-block.mt-5.product-block-star-rating.hidden.text-sm,
    .product-block-price,
    .product-block-quantity-selector {
        display: none !important;
    }
    @media (max-width: 1023px) {
            .bb-mobile-header-clone {
                padding-left: 5%;
                padding-right:5%;
            }

        div > .bb-judgeme-override {
            width: 100vw;
        }
        .jdgm-carousel__item-container > .jdgm-carousel__item-wrapper > .jdgm-carousel-item {
            margin: 0px !important;
        }

        /* Ensure the parent container acts as a flex column */
        .branded-lp-buybox .product-content .product-block-container > .relative {
            display: flex !important;
            flex-direction: column !important;
        }

        /* 1. Star Rating */
        .branded-lp-buybox .product-content .product-block-container > .relative > .product-block-star-rating {
            order: 1 !important;
        }

        /* 2. Product Title */
        .branded-lp-buybox .product-content .product-block-container > .relative > .product-block-title {
            order: 2 !important;
        }

        /* 3. Product Price */
        .branded-lp-buybox .product-content .product-block-container > .relative > .product-block-price {
            order: 3 !important;
        }

        /* 4. Choose your flavor / Choose your pack */
        .branded-lp-buybox .product-content .product-block-container > .relative > .custom-buybox-ui {
            order: 4 !important;
        }

        /* 5. Subscribe & Save / One-time purchase widget */
        .branded-lp-buybox .product-content .product-block-container > .relative > [class*="product-block-@app"] {
            order: 5 !important;
            margin-top: 0;
        }
        .branded-lp-buybox .product-content .product-block-container > .relative > [class*="product-block-@app"] > .branded-lp-buybox__flavor-selector
        
        /* 6. Quantity Selector */
        .branded-lp-buybox .product-content .product-block-container > .relative > .product-block-quantity-selector {
            order: 6 !important;
        }

        /* 7. CTA / Buy Buttons */
        .branded-lp-buybox .product-content .product-block-container > .relative > .product-block-buy-buttons {
            margin-top: 12px;
            order: 7 !important;
        }

        /* 8. Amazon Link */
        .branded-lp-buybox .product-content .product-block-container > .relative > .custom-amazon-link-wrapper {
            order: 8 !important;
        }
    }
}


.custom-sticky-cta {
    position: fixed;
    bottom: 24px;
    left: 50%;
    transform: translateX(-50%); 
    width: calc(100% - 32px);
    max-width: 440px;
    background-color: rgba(25, 25, 25, 0.85); 
    backdrop-filter: blur(12px);
    -webkit-backdrop-filter: blur(12px);
    border: 1px solid rgba(255, 255, 255, 0.15);
    border-radius: 12px;
    padding: 12px 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.5);
    z-index: 2147483647;
    box-sizing: border-box;
    opacity: 1; 
    pointer-events: auto; 
    font-family: inherit;
}
.custom-sticky-cta-left { display: flex; align-items: center; gap: 12px; overflow: hidden; }
.custom-sticky-cta-left img { width: 48px; height: 48px; border-radius: 8px; object-fit: cover; background-color: transparent; flex-shrink: 0; }
.custom-sticky-cta-text { display: flex; flex-direction: column; justify-content: center; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
#custom-sticky-cta-title { color: #fff; font-size: 14px; font-weight: 800; text-transform: uppercase; margin: 0 0 2px 0; line-height: 1.1; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
#custom-sticky-cta-price { color: #d1d5db; font-size: 13px; font-weight: 500; margin: 0; line-height: 1.1; min-height: 14px;}
#custom-sticky-cta-btn { background-color: #fff; color: #000; border: none; border-radius: 8px; padding: 12px 20px; font-size: 14px; font-weight: 800; cursor: pointer; white-space: nowrap; flex-shrink: 0; transition: background-color 0.2s ease, transform 0.1s ease; }
#custom-sticky-cta-btn:active { transform: scale(0.96); }
#custom-sticky-cta-btn:disabled { opacity: 0.6; cursor: not-allowed; }
@media (min-width: 1024px) { .custom-sticky-cta { display: none !important; } }

/* Custom Subtitle Styles */
.custom-subtitle {
    margin-top: 6px;
    margin-bottom: 24px;
    font-family: inherit;
    color: #4a4a4a;
    font-size: 16px;
    font-weight: 500;
    line-height: 1.4;
    text-transform: uppercase;
    letter-spacing: 0px;
}
.bb-mobile-header-clone .custom-subtitle {
    text-align: center;
    margin-bottom: 20px;
}
  </style>
`,
		);

		document.querySelector('[id*="__rich_text_"] > section')?.prepend(document.querySelector('[id*="icon-row-template--"]'));

		document.querySelectorAll('div > fieldset > div > div.subscription-plan-wrapper.one-time.top > input').forEach((elm) => {
			elm.click();
		});

		if (!document.getElementById('custom-sticky-cta')) {
			document.querySelector('body').insertAdjacentHTML(
				'beforeend',
				`<div id="custom-sticky-cta" class="custom-sticky-cta">
      <div class="custom-sticky-cta-left">
        <img id="custom-sticky-cta-img" src="" alt="Selected Product Flavor">
        <div class="custom-sticky-cta-text">
          <div id="custom-sticky-cta-title"></div>
          <div id="custom-sticky-cta-price"></div>
        </div>
      </div>
      <button id="custom-sticky-cta-btn">Add to cart</button>
    </div>`,
			);
		}


		function updateEverything() {
			try {
	
				document.querySelectorAll('.product-block-buy-buttons').forEach((btnContainer) => {
				
					const parentContainer = btnContainer.parentElement;
					if (!parentContainer) return;

					const titleLink = parentContainer.querySelector('.product-block-title a');
					if (!titleLink) return;

					const activeHref = (titleLink.getAttribute('href') || '').toLowerCase();

					let amazonUrl = '';
					if (activeHref.includes('mixed-berry') || activeHref.includes('mixedberry')) {
						amazonUrl = 'https://www.amazon.com/BUZZ-BOMB-Energy-Packets-Caffeine/dp/B0H2GCG8NY?ref_=ast_sto_dp&th=1';
					} else if (activeHref.includes('peach-mango') || activeHref.includes('peachmango')) {
						amazonUrl = 'https://www.amazon.com/BUZZ-BOMB-Energy-Packets-Caffeine/dp/B0H2FSF5HG?ref_=ast_sto_dp&th=1';
					} else if (activeHref.includes('variety')) {
						amazonUrl = 'https://www.amazon.com/BUZZ-BOMB-Energy-Packets-Caffeine/dp/B0H2G5Y55G?ref_=ast_sto_dp&th=1';
					}

					let amazonWrapper = parentContainer.querySelector(':scope > .custom-amazon-link-wrapper');
					if (!amazonWrapper) {
						amazonWrapper = document.createElement('div');
						amazonWrapper.className = 'custom-amazon-link-wrapper';
						amazonWrapper.innerHTML = `<a href="" target="_blank" rel="noopener noreferrer" style="display: inline-block;">
                            <img src="https://i.imgur.com/CeDos9c.png" alt="Available at Amazon">
                        </a>`;
						btnContainer.insertAdjacentElement('afterend', amazonWrapper);
					}

					const aTag = amazonWrapper.querySelector('a');
					if (amazonUrl) {
						if (amazonWrapper.style.display !== 'flex') amazonWrapper.style.display = 'flex';
						if (aTag.href !== amazonUrl) aTag.href = amazonUrl;
					} else {
						if (amazonWrapper.style.display !== 'none') amazonWrapper.style.display = 'none';
					}
				});

			
				document.querySelectorAll('.product-block-title').forEach((titleContainer) => {
					const aTag = titleContainer.querySelector('a');
					if (!aTag) return;

					const href = (aTag.getAttribute('href') || '').toLowerCase();
					const isVariety = href.includes('variety');
					const expectedHTML = isVariety
						? '20 PACKETS | 50 MG CAFFEINE<br>4 COFFEE MOCHA, 4 MIXED BERRY, 4 PEACH MANGO, AND 4 TROPICAL'
						: '20 PACKETS | 50 MG CAFFEINE';

					let subtitle = titleContainer.querySelector('.custom-subtitle');
					if (!subtitle) {
						subtitle = document.createElement('div');
						subtitle.className = 'custom-subtitle';
						aTag.insertAdjacentElement('afterend', subtitle);
					}
					if (subtitle.innerHTML !== expectedHTML) {
						subtitle.innerHTML = expectedHTML;
					}
				});

			
				const stickyCta = document.getElementById('custom-sticky-cta');
				if (stickyCta) {
					const visibleBtnBlocks = Array.from(document.querySelectorAll('.product-block-buy-buttons')).filter(
						(el) => el.getBoundingClientRect().height > 0,
					);
					const activeBtnBlock = visibleBtnBlocks[0];

					if (activeBtnBlock) {
						const parentContainer = activeBtnBlock.parentElement;

						let activeName = '';
						const titleH2 = parentContainer.querySelector('.product-block-title h2');
						if (titleH2) activeName = titleH2.textContent.trim();

						let priceStr = '';
						const checkedRadios = Array.from(
							parentContainer.querySelectorAll('input[name^="purchase_option"]:checked, input[name^="selling_plan_group"]:checked'),
						);
						for (let i = 0; i < checkedRadios.length; i++) {
							const innerWrapper = checkedRadios[i].closest('.purchase-option-details, .subscription-plan-details, .subscription-plan-wrapper');
							if (innerWrapper) {
								const priceEls = Array.from(
									innerWrapper.querySelectorAll(
										'.purchase-option-price-amount:not(.hidden), .purchase-option-price:not(.hidden), .selling-plan-price:not(.hidden)',
									),
								);
								const visiblePriceEl = priceEls.find((el) => el.textContent.trim()) || priceEls[0];
								if (visiblePriceEl && visiblePriceEl.textContent.trim()) {
									priceStr = visiblePriceEl.textContent.trim();
									break;
								}
							}
						}

						if (!priceStr) {
							const activePacks = Array.from(parentContainer.querySelectorAll('.pack-card.is-selected .pack-price'));
							const visiblePack = activePacks.find((el) => el.getBoundingClientRect().width > 0) || activePacks[0];
							if (visiblePack && visiblePack.textContent.trim()) priceStr = visiblePack.textContent.trim();
						}

						if (!priceStr) {
							const mainPrices = Array.from(
								parentContainer.querySelectorAll(
									'.product-block-price [data-product-price], .product-block-price [x-html="formatMoney(currentPrice)"]',
								),
							);
							const visibleMain = mainPrices.find((el) => el.textContent.trim().includes('$')) || mainPrices[0];
							if (visibleMain && visibleMain.textContent.trim()) priceStr = visibleMain.textContent.trim();
						}

						if (priceStr) priceStr = priceStr.replace(/\s+/g, ' ').trim();

						let btnText = 'Add to cart';
						let isBtnDisabled = false;
						const mainAtcBtn = activeBtnBlock.querySelector('button.add-to-cart-btn, button[name="add"], button[type="submit"]');
						if (mainAtcBtn) {
							isBtnDisabled = mainAtcBtn.disabled || mainAtcBtn.classList.contains('cursor-not-allowed');
							const xText = mainAtcBtn.querySelector('[x-text="addToCartText"]');
							if (xText && xText.textContent.trim()) {
								btnText = xText.textContent.trim();
							} else {
								btnText = mainAtcBtn.textContent.trim() || btnText;
							}
						}

						// Active image
						let activeImg = '';
						const activeThumb = document.querySelector('.product-thumbnail-list-item--active img, .is-active img');
						if (activeThumb) {
							activeImg = activeThumb.src;
						} else {
							const activeSquare = parentContainer.querySelector('.flavor-square .bb-border-accent');
							if (activeSquare) {
								const imgEl = activeSquare.closest('.flavor-square').querySelector('img');
								if (imgEl) activeImg = imgEl.src;
							}
						}

						const ctaTitle = document.getElementById('custom-sticky-cta-title');
						const ctaPrice = document.getElementById('custom-sticky-cta-price');
						const ctaImg = document.getElementById('custom-sticky-cta-img');
						const ctaBtn = document.getElementById('custom-sticky-cta-btn');

						if (ctaTitle && activeName && ctaTitle.textContent !== activeName) ctaTitle.textContent = activeName;
						if (ctaPrice && priceStr && ctaPrice.textContent !== priceStr) {
							ctaPrice.textContent = priceStr;
							if (priceStr !== lastPriceLogged) lastPriceLogged = priceStr;
						}
						if (ctaImg && activeImg && ctaImg.src !== activeImg) ctaImg.src = activeImg;
						if (ctaBtn && ctaBtn.textContent !== btnText) ctaBtn.textContent = btnText;
						if (ctaBtn && ctaBtn.disabled !== isBtnDisabled) ctaBtn.disabled = isBtnDisabled;
					}
				}
			} catch (e) {}
		}

		const stickyBtnElement = document.getElementById('custom-sticky-cta-btn');
		if (stickyBtnElement) {
			stickyBtnElement.addEventListener('click', (e) => {
				e.preventDefault();
				const visibleBtnBlocks = Array.from(document.querySelectorAll('.product-block-buy-buttons')).filter(
					(el) => el.getBoundingClientRect().height > 0,
				);
				const activeBtnBlock = visibleBtnBlocks[0];
				if (activeBtnBlock) {
					const mainAtcBtn = activeBtnBlock.querySelector('button.add-to-cart-btn, button[name="add"], button[type="submit"]');
					if (mainAtcBtn && !mainAtcBtn.disabled && !mainAtcBtn.classList.contains('cursor-not-allowed')) {
						mainAtcBtn.click();
					}
				}
			});
		}

		document.addEventListener('click', (e) => {
			if (e.target.closest('.flavor-square') || e.target.closest('.pack-card')) {
				setTimeout(updateEverything, 50);
			}
		});

		setInterval(updateEverything, 150);
		updateEverything();
	}

	console.log(
		'%cBB-02 | Product Page Redesign',
		"color: white; background-color:#202621; font-weight: bold; font-family:'SpaceGrotesk', sans-serif;",
	);

	function poll(sel, cb) {
		setTimeout(function () {
			if (document.querySelector(sel)) cb();
			else poll(sel, cb);
		}, 50);
	}

	poll('[id*="__rich_text_"] > section', init);
})();


} else {
    // It's a good idea to let control variant always be the default behaviour,
    // so if something goes wrong with flag evaluation, you don't break your app.
}